import React, { useEffect, useState } from 'react'
import { CommonHeader, EmptyListPage, ErrorSuccessModal, TableLoader } from '../../../components/commons'
import { resetSession } from '../../../redux/auth'
import { RootState } from '../../../redux/rootReducers'
import { GetJobsListTypePayload, JobsTypeListType, SingleJobTypeStatusChangePayload } from '../../../commonTypes/jobsType'
import { changeJobsTypeStatusAction, getJobsTypeListAction, resetError, resetJobsTypeList, resetMessage, resetStatusCode, resetSuccess } from '../../../redux/jobs'
import { connect } from 'react-redux'
import "../styles/jobs.scss"
import JobsTypeTable from '../../../components/Jobs/JobsType/AddEditJobType/JobsTypeTable'
import { SearchIcon } from '../../../components/Icon'
import {  NoDataImage } from '../../../assets/images'
import InfiniteLoader from '../../../components/commons/InfiniteLoader/InfiniteLoader'
import ScrollToTop from '../../../components/commons/ScrollToTop'
import useDebounce from '../../../customHooks/useDebounce'
import { useMenuCheck } from '../../../customHooks/useMenuCheck'


type AppProps = {
    token: string | null;
    success: number | null;
    fetching: boolean;
    error: string | null | undefined;
    message: string | null | undefined;
    statusCode: number | null;
    history?: any;
    jobsTypeList: JobsTypeListType[] | [];
    jobsTypeListTotalCount: number;
    dispatchResetSession: () => void;
    dispatchResetError: () => void;
    dispatchResetSuccess: () => void;
    dispatchResetJobsTypeList: () => void;
    dispatchResetMessage: () => void;
    dispatchResetStatusCode: () => void;
    dispatchGetJobsTypeAction: (data: GetJobsListTypePayload) => void;
    dispatchChangeJobsTypeStatus: (data:SingleJobTypeStatusChangePayload) => void;
}


const JobTypes = ({
    token,
    success,
    fetching,
    error,
    statusCode,
    history,
    jobsTypeList,
    jobsTypeListTotalCount,
    message,
    dispatchResetSession,
    dispatchResetError,
    dispatchResetSuccess,
    dispatchResetJobsTypeList,
    dispatchResetMessage,
    dispatchResetStatusCode,
    dispatchGetJobsTypeAction,
    dispatchChangeJobsTypeStatus
}: AppProps) => {
    const searchTermFromLocation = history?.location?.state?.searchTerm
    const [searchTerm, setSearchTerm] = useState<string>(searchTermFromLocation); 
    const [data, setData] = useState<JobsTypeListType[] | []>([]);
    const [offset, setOffset] = useState<number>(0);
    const [limit, setLimit] = useState<number>(20);
    const [clearSearch, setClearSearch] = useState<boolean>(false);
    const [isAddJobsTypePresent,setIsAddJobsTypePresent] = useMenuCheck();
    const [isEditJobsTypePresent,setIsEditJobsTypePresent]=useMenuCheck();
    const [isViewChecklist,setIsViewCheckList]=useMenuCheck();



    useEffect(() => {
        window.scroll({
            top:0,
            left:0
          })
        setIsAddJobsTypePresent("Add Jobs Type","menu")
        setIsEditJobsTypePresent("Edit Jobs Type","menu")
        setIsViewCheckList("Jobs Checklist","menu")
        dispatchResetError()
        dispatchResetSuccess()
        dispatchResetJobsTypeList()
        dispatchResetMessage()
        dispatchResetStatusCode()
        setData([])
    }, [])


    useEffect(() => {
        if (jobsTypeList?.length === 0) {
            setData(jobsTypeList)
        } else if (offset > 0 && jobsTypeList?.length > 0) {
            setData((prv: any) => [...prv, ...jobsTypeList]);
        } else {
            setData(jobsTypeList);
        }
    }, [jobsTypeList]);

    useEffect(() => {
        if (token) {
            let finalData = {
                token,
                search_term: searchTerm,
                limit,
                offset
            };

            if (jobsTypeListTotalCount) {
                if (+jobsTypeListTotalCount > offset) {
                    dispatchGetJobsTypeAction(finalData)
                }
            } else {
                dispatchGetJobsTypeAction(finalData)
            }
        }
    }, [offset]);



    const onScroll = () => {
        if (!fetching) {
            const scrollTop = document.documentElement.scrollTop
            const scrollHeight = document.documentElement.scrollHeight
            const clientHeight = document.documentElement.clientHeight

            if (offset < +jobsTypeListTotalCount && !fetching && Math.ceil(75 / 100 * scrollHeight) <= scrollTop + clientHeight) {
                if (jobsTypeList?.length > 0) {
                    if (!fetching && offset < +jobsTypeListTotalCount) {
                        setOffset(offset + limit)
                    }
                }
            }
        }
    }


    useEffect(() => {
        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    }, [jobsTypeList])

    useEffect(() => {
        if (clearSearch) {
            let finalData = {
                token,
                search_term: searchTerm,
                limit,
                offset: 0
            };
            if (searchTerm?.length === 0) {
                dispatchResetJobsTypeList();
                dispatchGetJobsTypeAction(finalData)
                setOffset(0);
            }
        }
    }, [clearSearch, searchTerm]);

    useDebounce(
        () => {
            if (searchTerm) {
                fetchNewData();
            }
        },
        500,
        [searchTerm]
    );

    const fetchNewData = () => {
        let finalData = {
            token,
            search_term: searchTerm,
            limit,
            offset: 0
        };
        if (token) {
            setClearSearch(true)
            if (offset === 0) {
                dispatchGetJobsTypeAction(finalData)
                setOffset(0);
            } else {
                setOffset(0);
            }
        }
    };

    const handleSearch = (e: any) => {
        setSearchTerm(e.target.value);
    };

    const handleChangeStatus=(status:any,id:string)=>{
        if(token){
            dispatchChangeJobsTypeStatus({id,status:!status ? 1 : 0,token})
        } 
    }

    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                )
            } else if ((!!error && statusCode !== 401)) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetSuccess()
                            dispatchResetMessage()
                            dispatchResetError()
                            dispatchResetStatusCode()
                        }}
                    />
                )
            }
        }
        else if(success===1){

           window.scrollTo(0, 0);
           dispatchResetJobsTypeList()
            if (offset === 0) {
                if (token) {
                    let finalData = {
                        token,
                        search_term: searchTerm,
                        limit,
                        offset
                    };

                    dispatchGetJobsTypeAction(finalData)
                }
              } else {
                setOffset(0);
              }
            dispatchResetSuccess()
            dispatchResetMessage()
            dispatchResetStatusCode()
            } 
            return false;     
    }


    return (
        <div className="row">
            <div className="col-md-4 mb-3">
                <CommonHeader title="Jobs Type" />
            </div>

            <div className="col-md-12">
                <div className='jobs-card'>
                    <div className="header">

                        <div className="left-header">
                            <div className="heading">Jobs Type</div>
                            <div className="sub-heading">{`Total ${jobsTypeListTotalCount ? jobsTypeListTotalCount : 0} entries found`}</div>
                        </div>

                     
                        <div className='right-header'>
                            <div className="col-md-7 position-relative" >
                                <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                                    <SearchIcon />
                                </span>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Search"
                                    onChange={(e: any) => handleSearch(e)}
                                    style={{ paddingLeft: "35px" }}
                                    value={searchTerm}
                                />
                            </div>
                            {/* <div>filter</div> */}
                           {isAddJobsTypePresent && <button onClick={() => history.push("/jobs/jobs-list/create-jobs-type")} className="btn btn-primary">
                                + Add Jobs Type
                            </button>}
                        </div>

                    </div>

                    <div>
                        {(fetching && offset === 0) ? <TableLoader Rows={10} ColumnPerRow={7} />
                            : jobsTypeList?.length > 0 ? (
                                <JobsTypeTable
                                    history={history}
                                    data={data}
                                    isViewChecklist={isViewChecklist}
                                    handleChangeStatus={handleChangeStatus}
                                    isEditJobsTypePresent={isEditJobsTypePresent}
                                    searchTerm={searchTerm}
                                />) :
                                (<div className='mt-5'style={{padding:"0px 50px 50px 50px"}}>
                                    <EmptyListPage
                                        title='No Jobs Type List Found!'
                                        image={NoDataImage}
                                        imageWidth="30%"
                                        showLinkButton={false}
                                        showAddButton={false}
                                    />
                                </div>)
                        }
                    </div>
                    {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                    <div style={{ display: fetching ? "none" : "inline" }}><ScrollToTop /></div>
                </div>
            </div>
            {handleErrorModal()}

        </div>
    )
}

const mapStateTopProps = (state: RootState) => ({
    token: state.auth.token,
    jobsTypeList: state.jobs.jobsTypeList,
    jobsTypeListTotalCount: state.jobs.jobsTypeListTotalCount,
    fetching: state.jobs.jobTypeFetching,
    success: state.jobs.success,
    statusCode: state.jobs.statusCode,
    error: state.jobs.error,
    message: state.jobs.message
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetSuccess: () => dispatch(resetSuccess()),
    dispatchResetMessage: () => dispatch(resetMessage()),
    dispatchResetError: () => dispatch(resetError()),
    dispatchResetStatusCode: () => dispatch(resetStatusCode()),
    dispatchResetJobsTypeList: () => dispatch(resetJobsTypeList()),
    dispatchGetJobsTypeAction: (data: GetJobsListTypePayload) => dispatch(getJobsTypeListAction(data)),
    dispatchChangeJobsTypeStatus : (data:SingleJobTypeStatusChangePayload) => dispatch(changeJobsTypeStatusAction(data))
})

export default connect(mapStateTopProps, mapDispatchToProps)(JobTypes)